import { Navigate, Outlet } from 'react-router-dom'
import { readFromToken } from './auth.ts';

const ProtectedRoutes = ({ kind }) => {
  const role = readFromToken('role');

  return (
    (role === kind) ? <Outlet/> : <Navigate to='/' />
  );
}

export default ProtectedRoutes;